import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * RotatingText — cycles through `words` with a smooth swap animation.
 * Each word is rendered with a gradient. Used in the hero headline.
 */
const RotatingText = ({ words, interval = 2200, className = '' }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((x) => (x + 1) % words.length), interval);
    return () => clearInterval(id);
  }, [words.length, interval]);

  return (
    <span className={`relative inline-block align-baseline ${className}`} data-testid="rotating-text">
      <AnimatePresence mode="wait">
        <motion.span
          key={words[i]}
          initial={{ opacity: 0, y: 24, filter: 'blur(8px)' }}
          animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
          exit={{ opacity: 0, y: -24, filter: 'blur(8px)' }}
          transition={{ duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] }}
          className="inline-block bg-gradient-to-r from-[#FF6B4A] via-[#FBBF24] to-[#FF6B4A] bg-clip-text text-transparent bg-[length:200%_auto]"
          style={{ animation: 'gradient-shift 3s ease infinite' }}
        >
          {words[i]}
        </motion.span>
      </AnimatePresence>
    </span>
  );
};

export default RotatingText;
